import React from 'react'

export default function ReinGuide () {
  return (
    <div>
      ReinGuide
    </div>
  )
}
